<template>
  <el-container class="NoteSelectForm">
    <el-main class="p-0">
      <ATable
        ref="table"
        v-loading="loading"
        :placeholder="placeholder"      
        :search_field="search_field"
        :data="data"
        hide-button-insert
        border
        @row-click="handleClickRow"
      >
        <el-table-column 
          type="index" 
          label="No" 
          :index="handleIndex" 
          :width="$width.index" 
        />
        <el-table-column 
          prop="number" 
          label="어음번호" 
          width="100" 
        />
        <el-table-column 
          prop="type_flag" 
          label="구분" 
          width="50"
          :formatter="resolveTypeFlag" 
        />
        <el-table-column 
          prop="pay_date" 
          label="지급일" 
          :width="$width.date"
        />
        <el-table-column
          prop="price"
          label="금액"
          class-name="cell-number"
          :formatter="util.numberFormat"
        />
        <el-table-column 
          prop="desc" 
          label="기록사항" 
          show-overflow-tooltip 
        />
        <el-table-column 
          prop="in_date" 
          label="입고일" 
          :width="$width.date"
        />
        <el-table-column 
          prop="in_flag" 
          label="구분" 
          width="50"
          :formatter="resolveInFlag" 
        />
        <el-table-column 
          prop="in_customer_name" 
          label="입고처" 
          width="80"
          show-overflow-tooltip 
        />
        <el-table-column 
          prop="publish_date" 
          label="발행일" 
          :width="$width.date"
        />
        <el-table-column 
          prop="publisher" 
          label="발행자" 
          width="70"
          show-overflow-tooltip 
        />
        <el-table-column 
          prop="bank_name" 
          label="발행은행" 
          width="80"
          show-overflow-tooltip 
        />
        <el-table-column 
          prop="endorser1" 
          label="배서인1" 
          width="70"
          show-overflow-tooltip 
        />
        <el-table-column 
          prop="endorser2" 
          label="배서인2" 
          width="70"
          show-overflow-tooltip 
        />
        <el-table-column 
          prop="endorser3" 
          label="배서인3" 
          width="70"
          show-overflow-tooltip 
        />
      </ATable>
    </el-main>
    <el-footer>
      <el-button class="right" @click="closeDialog">{{$t('button.close')}} (Esc)</el-button>
    </el-footer>
  </el-container>
</template>

<script>
export default {
  name: "NoteSelectForm",
  data() {
    return {
      title: this.$t('title.note'),
      loading: false,
      placeholder: "어음번호,입고처,발행처",
      search_field: ["number", "in_customer_name", "publisher"],
      data: [],
    };
  },
  mounted() {
    this.$nextTick(() => this.loadData());
  },
  methods: {    
    loadData() {
      this.loading = true;
      this.api.listNoteRemain().then(res => {
        this.loading = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.data = res.data;
      });
    },
    resolveTypeFlag(row, column, value) {
      let flag = this.system.options.note_type_flag.find(t => t.value === value);
      return flag ? flag.label : '';
    },
    resolveInFlag(row, column, value) {
      let flag = this.system.options.note_in_flag.find(t => t.value === value);
      return flag ? flag.label : '';
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleClickRow(data) {
      this.$emit('completed', Object.assign({}, data));
    },    
    closeDialog() {
      this.$emit('completed');
    },
  }
};
</script>
